import { observer } from 'mobx-react';
import { Component } from 'react';
import { ORDER_DELIVERY_TYPES } from 'src/constants/deliveryTypes';
import { BUTTON_TITLE } from 'src/constants/main';
import { ORDER_STATUS } from 'src/constants/order';
import { localeStore } from 'src/mobx/localesStore';
import { TOrder } from 'src/types/orders';
import { orderStatusManager } from 'src/utils/orderStatusManager';
import ModalMessage from 'src/view/components/ModalMessage/ModalMessage';
import PopupModal from 'src/view/components/Popup/Popup';
import OrderStatusButton from 'src/view/screens/OrderScreen/components/OrderStatusButton/OrderStatusButton';
import { OrderStore } from '~/mobx/orderStore';
import logger from '~/services/logger';
import { IMessageModalOption } from '~/view/containers/Messages';
import { withOrderStore } from '~/view/screens/OrderScreen/context';
import './style.scss';

interface IState {
  changeStatusModal: boolean;
  completedStatusModal: boolean;
  currentOrder: {
    id: TOrder['id'] | undefined;
    status: TOrder['status'] | undefined;
  };
  nextStatusCode: TOrder['order_status_code'];
  excludeNextButton: boolean;
  messageText: string;
  completedButton: boolean;
}

// @ts-ignore
@withOrderStore
@observer
export default class OrderStatusButtons extends Component<{ orderStore?: OrderStore }, IState> {
  state = {
    changeStatusModal: false,
    completedStatusModal: false,
    currentOrder: {
      id: undefined,
      status: undefined,
    },
    nextStatusCode: ORDER_STATUS.PENDING,
    excludeNextButton: false,
    messageText: '',
    completedButton: false,
  };

  get orderStore() {
    return this.props.orderStore!;
  }

  openChangeStatusModal = () => {
    this.setState({ changeStatusModal: true });
  };

  closeChangeStatusModal = () => {
    this.setState({ changeStatusModal: false });
  };

  changeStatus = async () => {
    try {
      if (!this.orderStore.order) return;
      await this.orderStore.changeStatus(this.orderStore.order.id, this.state.nextStatusCode);
      this.setState({ currentOrder: { id: undefined, status: undefined } }, this.closeChangeStatusModal);
    } catch (error: any) {
      this.closeChangeStatusModal();
      logger.error({ error, place: 'OrderStatusButtons changeStatus', showModal: true });
    }
  };

  openCompletedStatusModal = () => {
    this.setState({ completedStatusModal: true });
  };

  closeCompletedStatusModal = () => {
    this.setState({ completedStatusModal: false });
  };

  completedStatus = async () => {
    try {
      if (!this.orderStore.order) return;
      await this.orderStore.changeStatus(this.orderStore.order.id, ORDER_STATUS.COMPLETED);
      this.setState({ currentOrder: { id: undefined, status: undefined } }, this.closeCompletedStatusModal);
    } catch (error: any) {
      this.closeCompletedStatusModal();
      logger.error({ error, place: 'OrderStatusButtons completedStatus', showModal: true });
    }
  };

  handleStatus = () => {
    if (this.orderStore.order?.foodics_id !== '') {
      this.openChangeStatusModal();
    } else {
      this.changeStatus();
    }
  };

  updateStatus = () => {
    const response = orderStatusManager(this.orderStore.order);
    if (!response) return null;
    this.setState({
      messageText: response.messageText,
      nextStatusCode: response.nextStatusCode,
      completedButton: response.completedButton,
      currentOrder: { id: this.orderStore.order?.id, status: this.orderStore.order?.status },
    });
    this.checkExclusions(response);
  };

  checkExclusions = (response: any) => {
    let exclude = false;
    if (response.nextStatusCode === ORDER_STATUS.RETURNED && this.orderStore.order?.delivery_type_code !== ORDER_DELIVERY_TYPES.DELIVERY_ADDRESS) {
      exclude = true;
    }
    this.setState({ excludeNextButton: exclude });
  };

  componentDidMount = () => {
    this.updateStatus();
  };

  componentDidUpdate = () => {
    if (this.orderStore.order?.id !== this.state.currentOrder.id || this.orderStore.order?.status !== this.state.currentOrder.status) {
      this.updateStatus();
    }
  };

  get isHidden() {
    return this.orderStore.order?.order_status_code === ORDER_STATUS.CANCELED || this.orderStore.order?.order_status_code === ORDER_STATUS.COMPLETED;
  }

  get changeStatusMessageOptions(): IMessageModalOption[] {
    return [
      { title: localeStore.t(BUTTON_TITLE.YES), onPress: this.changeStatus, loading: this.orderStore.loading },
      { title: localeStore.t(BUTTON_TITLE.NO), onPress: this.closeChangeStatusModal, appearance: 'tertiary' },
    ];
  }

  get completeOrderMessageOptions(): IMessageModalOption[] {
    return [
      { title: localeStore.t(BUTTON_TITLE.YES), onPress: this.completedStatus, loading: this.orderStore.loading },
      { title: localeStore.t(BUTTON_TITLE.NO), onPress: this.closeCompletedStatusModal, appearance: 'tertiary' },
    ];
  }

  render() {
    if (this.isHidden) return null;

    console.log(this.state.nextStatusCode);

    return (
      <div className="order-status-buttons__container ml-4">
        {this.state.excludeNextButton ? null : (
          <>
            <PopupModal
              justify="end"
              selfClose={false}
              backdrop
              onClose={this.closeChangeStatusModal}
              visible={this.state.changeStatusModal}
              content={({ closeModal }) => (
                <ModalMessage
                  minWidth={300}
                  title={localeStore.t(this.state.messageText)}
                  closeModal={closeModal}
                  iconClassName="color-gray2"
                  options={this.changeStatusMessageOptions}
                />
              )}
            ></PopupModal>
            <OrderStatusButton orderStatusCode={this.state.nextStatusCode} onClick={this.handleStatus} loading={this.orderStore.loading} />
          </>
        )}

        {this.state.completedButton ? (
          <>
            <PopupModal
              justify="end"
              selfClose={false}
              backdrop
              onClose={this.closeCompletedStatusModal}
              visible={this.state.completedStatusModal}
              content={({ closeModal }) => (
                <ModalMessage
                  minWidth={300}
                  maxWidth={500}
                  title={localeStore.t(this.state.messageText)}
                  closeModal={closeModal}
                  iconClassName="color-gray2"
                  options={this.completeOrderMessageOptions}
                />
              )}
            ></PopupModal>
            <OrderStatusButton orderStatusCode={ORDER_STATUS.COMPLETED} onClick={this.openCompletedStatusModal} loading={this.orderStore.loading} />
          </>
        ) : null}
      </div>
    );
  }
}
